module.exports = {
  cognito: {
    key: 'cognito',
    label: 'Cognito',
  },
  custom: {
    key: 'custom',
    label: 'Custom',
  },
};